export const allowOnlyFourDigit = (value) => {
    if (!value) return value;
    const inputValue = value.replace(/[^\d{4}]/g, "");
    return `${inputValue.slice(0, 4)}`;
}

export const allowOnlyTwoDigit = (value) => {
    if (!value) return value;
    const inputValue = value.replace(/[^\d{2}]/g, "");
    return `${inputValue.slice(0, 2)}`;
}